import request from "@/utils/request";
import {IContainerTypeModel} from "./types";

export const defaultContainerType: IContainerTypeModel = {
    id: null,
    name: null,
    createdAt: null,
    value: null
};


export const getContainerTypeList = () =>
    request({
        url: `/container-types`,
        method: "get"
    });

export const createContainerType = (data: { name: string, value: string }) =>
    request({
        url: `/container-types`,
        method: "post",
        data
    });


export const deleteContainerType = (id: string) =>
    request({
        url: `/container-types/${id}`,
        method: "delete"
    });


export const updateContainerType = (id: string, data: { name: string, value: string }) =>
    request({
        url: `/container-types/${id}`,
        method: "put",
        data
    });
